// Angular
import { Injectable } from '@angular/core';

// RxJS
import { Observable } from 'rxjs';

// Local
import { ComparableDataService } from '@app/abstract-classes/comparable-data.service';


@Injectable({ providedIn: 'root' })
export abstract class ComparableArrayDataService<T> extends ComparableDataService<T[]> {
  /**
   * The collection of T objects exposed as an Observable.
   */
  override get data$(): Observable<T[]> {
    return super.data$ as Observable<T[]>;
  }
  
  /**
   * The collection of T objects.
   */
  override get data(): T[] {
    return super.data as T[];
  }
  
  /**
   * The original collection of T objects exposed as an Observable.
   */
  override get originalData$(): Observable<T[]> {
    return super.originalData$ as Observable<T[]>;
  }
  
  /**
   * The original collection of T objects.
   */
  override get originalData(): T[] {
    return super.originalData as T[];
  }
}